module.exports = "<div class=component-tips-item> <div class=msg>{{{msg}}}</div> <div class=close>╳</div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/util/tips/tips.html
// module id = 1890
// module chunks = 50